const UiCheckboxGroupPropsOption = {
  modelValue: { type: Array, required: true },
  name: { type: String },
  max: { type: Number },
  min: { type: Number }
};
const UiCheckboxGroupEmits = {
  change: () => true
};
const UiCheckboxGroupInjectionKey = Symbol("UiCheckboxGroupInjectionKey");

export { UiCheckboxGroupEmits, UiCheckboxGroupInjectionKey, UiCheckboxGroupPropsOption };
//# sourceMappingURL=index.mjs.map
